import { render } from "./InstructorHome.vue?vue&type=template&id=56c0d7e8&scoped=true"
import script from "./InstructorHome.vue?vue&type=script&lang=js"
export * from "./InstructorHome.vue?vue&type=script&lang=js"

import "./InstructorHome.vue?vue&type=style&index=0&id=56c0d7e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c0d7e8"]])

export default __exports__